module.exports = __webpack_public_path__ + "pnskfsquadron/img/book-hero10.png?56b5e0bc";